import React, { useState } from 'react';
import KickImage from 'Reuseables/KickImage';
import { Link } from 'react-router-dom';
import cn from "classnames"

/** Css */
import Styles from "./Card.module.scss"

import { emptyImage } from "utils"

type CardProps = {
  name: string;
  link: string;
  no: string;
  productImg: string;
  className?: string;
  category?: string;
};
const Card: React.FC<CardProps> = ({ name, link, productImg, no, className, category }) => {
  const [img, setImg] = useState(productImg)
  return (
    <Link to={link} className={cn(Styles['npl-card'], Styles[`${className}`])}>
      <p className={Styles["number"]}>{no}</p>
      <div className={Styles['img-box']}>
        <KickImage src={img} alt={name} onError={() => setImg(emptyImage(category))} />
      </div>
      <p className={Styles["name"]}>{name}</p>
    </Link>
  );
};

export default Card